import React__default from 'react';
import { Label } from 'reactstrap';
import { Controller } from '../../../../../../node_modules/.pnpm/react-hook-form@7.22.0_react@19.0.0/node_modules/react-hook-form/dist/index.esm.mjs.js';
import dayjs from 'dayjs';
import { useFormContext } from '../Form.js';
import DatePicker from '../../Components/Input/DatePicker/DatePicker.js';
import useConfig from '../../Hooks/useConfig.js';
import { FontAwesomeIcon } from '../../../../../../node_modules/.pnpm/@fortawesome_react-fontawesome@0.2.2_@fortawesome_fontawesome-svg-core@6.7.2_react@19.0.0/node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faExclamationTriangle } from '../../../../../../node_modules/.pnpm/@fortawesome_free-solid-svg-icons@6.7.2/node_modules/@fortawesome/free-solid-svg-icons/index.mjs.js';
import useAppService from '../../Hooks/useAppService.js';
import { sanitize } from '@ibe/services';

const FormDatePicker = (props) => {
    const { errorsProp, label, name, dataTestId, baseName, selectedDate, showErrors, boldLabel, showErrorIcon, placeholderText, withKeyboardSupport, showInModal, modalLabel, inLine, noInitialValueInput } = props;
    const { icon, ...rest } = props;
    const { register, errors, control } = useFormContext();
    const config = useConfig();
    const appService = useAppService();
    if (!register)
        return null;
    const formErrors = errorsProp || errors;
    const getDate = (date) => {
        if (date) {
            const dateParsed = date.split('-');
            return new Date(Number(dateParsed[0]), Number(dateParsed[1]) - 1, Number(dateParsed[2]));
        }
        else {
            return undefined;
        }
    };
    const handleChange = (date, onFieldChange) => {
        onFieldChange(date ? dayjs(date).format(config.formatDate) : undefined);
    };
    return (React__default.createElement("div", { className: `form__datepicker ${formErrors && showErrors && formErrors[baseName || name] ? 'input--error' : ''}` },
        !!label && (React__default.createElement(Label, { className: `${formErrors && showErrors && formErrors[baseName || name] ? 'form__error__top' : ''}${boldLabel ? ' font-weight-bold' : ''}`, dangerouslySetInnerHTML: { __html: sanitize(label, true) } })),
        React__default.createElement(Controller, { name: name, control: control, render: ({ field }) => {
                return (React__default.createElement("div", { className: "position-relative" },
                    React__default.createElement(DatePicker, { className: !!field.value ? 'input--filled' : '', ...rest, ...field, 
                        /* eslint-enable */
                        onChange: (date) => handleChange(date, field.onChange), onInvalidInputFormat: () => field.onChange(null), date: selectedDate ? selectedDate(field.value) : getDate(field.value), dataTestId: dataTestId, placeholderText: placeholderText, withKeyboardSupport: withKeyboardSupport, showInModal: showInModal, displayFormat: config.displayFormatDate[appService.lang.replace('-', '_')], inline: inLine, modalLabel: modalLabel, noInitialValueInput: noInitialValueInput }),
                    icon && (React__default.createElement("div", { className: "form__datepicker__icon__container" },
                        React__default.createElement(FontAwesomeIcon, { className: "form__datepicker__icon", icon: icon })))));
            } }),
        formErrors && showErrors
            ? formErrors[baseName || name] && (React__default.createElement("div", { className: "form__error" }, formErrors[baseName || name].message))
            : null,
        showErrorIcon && formErrors && showErrors && formErrors[baseName || name] && (React__default.createElement(FontAwesomeIcon, { icon: faExclamationTriangle }))));
};

export { FormDatePicker as default };
//# sourceMappingURL=FormDatePicker.js.map
